import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { COMMITMENT_VALUES } from "@/lib/data";

// "Our Commitment" — single-view slider showing one principle at a time.
export default function CommitmentSlider() {
  const [activeIdx, setActiveIdx] = useState(0);
  const total = COMMITMENT_VALUES.length;
  const goPrev = () => setActiveIdx((i) => (i - 1 + total) % total);
  const goNext = () => setActiveIdx((i) => (i + 1) % total);

  const v = COMMITMENT_VALUES[activeIdx];
  const accent = activeIdx % 2 === 0 ? "#24356E" : "#3397AC";

  return (
    <div className="relative max-w-4xl mx-auto" data-testid="commitment-slider">
      <div className="bg-white border border-slate-200 min-h-[320px] md:min-h-[340px] p-10 md:p-14 relative overflow-hidden">
        <div
          className="absolute top-0 left-0 h-1 w-24"
          style={{ background: accent }}
        />
        <div key={v.title}>
          <p className="text-xs font-bold uppercase tracking-[0.2em] mb-3" style={{ color: accent }}>
            Principle {activeIdx + 1} of {total}
          </p>
          <h3 className="text-2xl md:text-3xl font-bold mb-4 leading-tight">{v.title}</h3>
          <p className="text-base md:text-lg text-slate-600 leading-relaxed">{v.description}</p>
        </div>
      </div>

      <div className="mt-8 flex items-center justify-between gap-6">
        <div className="flex items-center gap-2" data-testid="commitment-slider-dots">
          {COMMITMENT_VALUES.map((val, i) => (
            <button
              key={val.title}
              type="button"
              data-testid={`commitment-dot-${i}`}
              aria-label={`Go to principle ${i + 1}`}
              onClick={() => setActiveIdx(i)}
              className="h-2 transition-all duration-300"
              style={{
                width: i === activeIdx ? "36px" : "10px",
                background: i === activeIdx ? "var(--zt-teal)" : "#CBD5E1",
              }}
            />
          ))}
        </div>
        <div className="flex items-center gap-3">
          <button
            type="button"
            data-testid="commitment-prev"
            aria-label="Previous principle"
            onClick={goPrev}
            className="w-11 h-11 flex items-center justify-center border border-slate-300 bg-white hover:border-slate-900 transition-colors"
          >
            <ChevronLeft size={18} />
          </button>
          <button
            type="button"
            data-testid="commitment-next"
            aria-label="Next principle"
            onClick={goNext}
            className="w-11 h-11 flex items-center justify-center transition-colors hover:opacity-90"
            style={{ background: "var(--zt-teal)", color: "#fff" }}
          >
            <ChevronRight size={18} />
          </button>
        </div>
      </div>
    </div>
  );
}
